import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";

export class Fossil extends Phaser.GameObjects.Sprite {
    name: string;
    dug: boolean;
    index: number;

    constructor(scene: Phaser.Scene, ob: TiledGameObject) {
        super(scene, ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", ob.name + "1");
        this.name = ob.name;
        this.index = 1;

        this.setAlpha(0.01);

        this.setInteractive();
        this.scene.add.existing(this);
    }


    dig() {
        this.index++;
        this.setFrame(this.name + this.index);

        if (this.index === 4) {
            this.dug = true;
            this.input.enabled = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/games/FossilFinderGame/objects/Fossil.ts